module.exports = __webpack_public_path__ + "img/Landing Photo.13ec03dd.jpg";